/**
 * 파일명: aboutLines.js
 * 작성자: 김준형
 * 작성일자: 26.08.11
 * 설명: About Us - 시안 그대로의 줄바꿈
 */
import React from "react";
import { useMediaQuery } from "react-responsive";

function useDesignLines() {
  const isWide = useMediaQuery({ query: "(min-width: 1601px)" });

  return (lines) => {
    if (!isWide) return lines.join("");

    return lines.map((line, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={index}>
        {index > 0 && <br />}
        {line}
      </React.Fragment>
    ));
  };
}

export default useDesignLines;
